import { ProgressBarInfoProps } from "./types/progressBarInfoProps";
import './progressBarInfo.scss';
import { ReactComponent as checkMarkIcon } from '../../../icons/check_circle.svg';
import { AdditionalIcon } from "../../shared/additionalIcon/additionalIcon";


const ProgressBarInfo = (props: ProgressBarInfoProps) => {
    let progressPercentage = 0;
    if (props.currentPercentage) {
        progressPercentage = props.currentPercentage;
        if (props.currentPercentage > 100) progressPercentage = 100;
        if (props.currentPercentage < 0) progressPercentage = 0;
    }

    return (
        <div className="progress-info-container" style={props.style}>
            <div>
                <p className="body-txt-medium">{props.fileName}</p>
                <p className="body-txt-small-orange">{props.uploadProcessStatus}</p>
            </div>
            <div>

            {progressPercentage === 100 ? (
                <p>{AdditionalIcon(checkMarkIcon)}</p>
            ) : (                
                <p className="body-txt-large-bold-orange">{progressPercentage}%</p>                
            )} 
            
            </div>         
        </div>
    )
}

export default ProgressBarInfo;